import { api } from '../../shared/shared.api';

export interface RoleWithPermissions {
  key: string;
  name: string;
  permissions: string[];
}

export function listRoles(): Promise<RoleWithPermissions[]> {
  return api<RoleWithPermissions[]>('/roles');
}
